import React from "react";
import {
  ArrowRight,
  CheckCheck,
  CircleEllipsis,
  Globe,
  Loader2,
  Truck,
} from "lucide-react";
import { Progress } from "../../src/components/ui/progress";
import { useQuery } from "react-query";
import { TrackingResponse } from "../lib/interfaces";

export default function TrackShipment({
  orderReference,
}: {
  orderReference: string;
}) {
  const [progress, setProgress] = React.useState(0);
  React.useEffect(() => {
    const timer = setTimeout(() => setProgress(0), 500);
    return () => clearTimeout(timer);
  }, []);

  const [error, setError] = React.useState("");
  const { data: shipment, isLoading } = useQuery(
    ["shipment", orderReference],
    async () => {
      setError("");

      try {
        const response = await fetch(
          "https://amadeussabra.com/amadeus/wp-json/tracking/v1/track-shipment",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              shipment_number: orderReference,
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to track shipment");
        }

        const data: TrackingResponse =
          await response.json();
        return data;
      } catch (err) {
        setError(
          "Error tracking shipment. Please try again."
        );
        console.error("Tracking error:", err);
      } finally {
        console.log(error);
      }
    },
    {
      enabled: !!orderReference,
      retry: false,
      onError: (error) => {
        console.error("Order processing error:", error);
      },
    }
  );

  return (
    <div className="h-full flex flex-col justify-center w-full items-center gap-10 border pl-20 pr-20 pt-5 pb-5">
      {/* <img
        src="/world-map.jpeg"
        className=" w-full h-full"
        alt=""
      /> */}

      <div className=" flex flex-col justify-center items-center gap-5">
        <h4 className="text-xl">Shipment Summary</h4>
        <Globe className="size-10 stroke-1" />
        <h5 className="text-sm">
          Shipment Number: {orderReference}
        </h5>
      </div>
      <div className="relative w-full">
        <div className=" h-20 w-1/2 absolute top-0 w-full">
          <div className="left-0 absolute top-0 z-20 flex -mt-4 flex-col justify-center items-center w-10">
            <div className="p-2 bg-white border border-neutral-900 dark:bg-neutral-900 dark:border dark:border-neutral-100 rounded-full">
              <CircleEllipsis />
            </div>
            <p className="text-sm text-center">
              Record Created
            </p>
          </div>
          <div className="left-0 absolute top-0 z-20 flex -mt-4 flex-col justify-center items-center w-full">
            <div className="p-2 bg-white border border-neutral-900 dark:bg-neutral-900 dark:border dark:border-neutral-100 rounded-full">
              <Truck />
            </div>
            <p className="text-sm text-center">
              In Transit
            </p>
          </div>
          <div className=" right-0 absolute top-0 z-20 flex -mt-4 flex-col justify-center items-center w-10">
            <div className="p-2 bg-white border border-neutral-900 dark:bg-neutral-900 dark:border dark:border-neutral-100 rounded-full">
              <CheckCheck />
            </div>
            <p className="text-sm text-center">Delivered</p>
          </div>
        </div>
        <Progress
          value={progress}
          className="w-full block z-10 h-2"
        />
      </div>
      <div className="flex justify-between items-center w-full text-sm mt-10 bg-neutral-100 p-10 dark:text-neutral-900">
        <h5>Chtaura, Lebanon</h5>
        <ArrowRight />
        {isLoading ? (
          <Loader2 className="size-5 animate-spin duration-500" />
        ) : (
          <h5>
            {
              shipment?.TrackingResults
                .KeyValueOfstringArrayOfTrackingResultmFAkxlpY
                .Value.TrackingResult[0].UpdateLocation
            }
          </h5>
        )}
      </div>
      <div className="flex flex-col gap-2 dark:text-neutral-100 border p-2 w-full">
        <span className="text-sm">Current Activity</span>
        {isLoading ? (
          <Loader2 className="size-5 animate-spin duration-500" />
        ) : (
          <span className="text-xl">
            {
              shipment?.TrackingResults
                .KeyValueOfstringArrayOfTrackingResultmFAkxlpY
                .Value.TrackingResult[0].UpdateDescription
            }
          </span>
        )}
      </div>
    </div>
  );
}
